import type { AppState } from '@protector/entities/__legacy__/redux.types';
import type { Season } from '@protector/entities/season/models';
import type { UUID } from '@protector/utils/types';
import { getActiveSeasonsIdsOrMostRecent } from 'entities/season/season.functions';
import { selectAllSeasons } from 'entities/season/season.reducer';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { BreadcrumbSeasonsGroup } from '../header/components/breadcrumb/breadcrumb-seasons.enum';

const useInitialSeasonSelection = ({ setCurrentSelected }: { setCurrentSelected: (value: UUID | null) => void }) => {
  const [localMode, setLocalMode] = useState<BreadcrumbSeasonsGroup>(BreadcrumbSeasonsGroup.ALL_ACTIVES);
  const seasons = useSelector<AppState, Season[]>(state => selectAllSeasons(state.entities.season));
  const setCurrentSelectedRef = useRef(setCurrentSelected);

  useEffect(() => {
    setCurrentSelectedRef.current = setCurrentSelected;
  }, [setCurrentSelected]);

  useEffect(() => {
    const { seasonsID, hasActiveSeason } = getActiveSeasonsIdsOrMostRecent(seasons);

    if (!hasActiveSeason && seasonsID?.length > 0) {
      setLocalMode(BreadcrumbSeasonsGroup.BY_SEASON);
      setCurrentSelectedRef.current(seasonsID[0]);
    }
  }, [seasons]);

  return {
    localMode,
    setLocalMode
  };
};

export { useInitialSeasonSelection };
